import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ActivityService, ActivityId, PdfActivityDisplayLabels } from '../../services/activity.service';
import { ActivityClassificationService } from '../../services/activity-classification.service';
import { UnitService } from '../../services/unit.service';
import { QuotationFunctionData } from '../../quotation-activity-functions';
import { Upload } from '../../services/upload/upload';

@Component({
  selector: 'app-display-activity',
  templateUrl: './display-activity.component.html',
  styleUrls: ['./display-activity.component.css', '../../app.component.css']
})

export class DisplayActivityComponent implements OnInit, OnDestroy {

    activity: any = [];

    id: string;

    gaSubs: any;
    
	pdfLabels = PdfActivityDisplayLabels;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private service: ActivityService,
        private classService: ActivityClassificationService,
        private unitService: UnitService,
		private quotationFunctionData: QuotationFunctionData
    ) {
        this.id = activatedRoute.snapshot.paramMap.get('id');
        this.gaSubs = this.service.getActivity(this.id).subscribe(({quantityPricesFunction: qpFunction, prices, minPrice=0, ...activity}: ActivityId) => {
            console.log(activity.ranges)
            let {selectName, labels } = quotationFunctionData.functionData[qpFunction];
            this.activity = {
                minPrice,
                ...activity,
                function: selectName,
                prices: prices.map((price, index) => ({label: labels[index], price}) )
            };
            console.log(activity);

            let gacSubs = this.classService.getActivityClassification(this.activity.activityClassificationRef.id).subscribe(classObj => {
                gacSubs.unsubscribe();
                this.activity.classificationName = classObj.name;
            });

            let gmuSubs = this.unitService.getUnit(this.activity.measurementUnitRef.id).subscribe(unit => {
                gmuSubs.unsubscribe();
                this.activity.valueUnit = this.activity.value + ' ' + unit.symbol;
            });

        });
    }

    ngOnInit() {

    }
    ngOnDestroy(){
        this.gaSubs.unsubscribe();
    }
  
    uploadFile(event) {
      var selectedFile: File = event.target.files[0];
      var currentUpload: Upload = new Upload(selectedFile);
      this.service.uploadPdfFile(currentUpload, this.id);
    }
  
    deleteFile(){
        this.service.deletePdfFile(this.id);
    }

}

